export default __webpack_public_path__ + "static/media/AMIS.f5ed202e.png";